import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge bg-info-soft"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clock me-1" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from "vue";
import { useMainStore } from "../store";
import { languages } from "../utils/languages";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimezoneAlert',
  props: {
    icon: { type: Boolean }
  },
  setup(__props: any) {

const session = computed(() => useMainStore().session);

const { icon } = __props;

return (_ctx: any,_cache: any) => {
  return (session.value.foreigner)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _hoisted_2,
        (_ctx.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(languages)["pt-br"].flag), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "Horário de Brasília"))
      ]))
    : _createCommentVNode("", true)
}
}

})